import React from 'react'
import { Outlet } from 'react-router-dom'
import './index.less'

export default () => {
  return <Outlet />
}
